import script from "./compare-table-desktop.vue?vue&type=script&setup=true&lang=js"
export * from "./compare-table-desktop.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__